export enum UserType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
